import { action, observable } from 'mobx';
import api from './api';


export const TOKEN_KEY = '@pes-backend';
export const TOKEN_KEY_REFRESH = '@pes-backend-r';


 class AuthStore {
  @observable isAuthenticated  = localStorage.getItem(TOKEN_KEY) !== null;

  @action
   async signIn(credentials){
    const response = await api.post('/api/token/', credentials);
    localStorage.setItem(TOKEN_KEY, response.data.access);
    localStorage.setItem(TOKEN_KEY_REFRESH, response.data.refresh);
    this.isAuthenticated = true;
  };

  @action
  signOut(){
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(TOKEN_KEY_REFRESH);
    this.isAuthenticated = false;
  }

  @action
  getToken(){
    return localStorage.getItem(TOKEN_KEY);
  }

};

export default new AuthStore();
